var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":("/tag/" + (tag.slug))},domProps:{"innerHTML":_vm._s(tag.title)}}),(index < _vm.tags.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-601469c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsList.vue
// module id = null
// module chunks = 